import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {SptRecorderService} from '@spout/global-web/data-access';

@Component({
  selector: 'spt-help-getting-started-creating-content',
  templateUrl: './help-getting-started-creating-content.component.html',
  styleUrls: ['./help-getting-started-creating-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HelpGettingStartedCreatingContentComponent {
  constructor(private _recorder: SptRecorderService) {}
  refresh(): void {
    this._recorder.refreshAudioDeviceList().subscribe(() => {});
  }
}
